<isd-file-transfer
  *isdIfPermitted="'customer.documents.canRead'"
></isd-file-transfer>
<isd-document-inbox-upload
  *isdIfPermitted="'customer.documentInbox.canCreate'"
></isd-document-inbox-upload>
